<template>
  <user-header></user-header>
  <breadcrumb :text="text" :text1="text1" :title="title"/>
  <user-tabset></user-tabset>
  <div class="content court-bg">
    <div class="container">
      <settings-sidebar></settings-sidebar>

      <div class="row">
        <div v-if="!hiddenForm" class="col-sm-12">
          <div class="profile-detail-group">
            <div class="card">
              <Form @submit="validateAndSubmit">
                <div class="row">
                  <div class="col-lg-7 col-md-7">
                    <div class="input-space">
                      <label class="form-label">
                        Mật khẩu cũ <span class="text-danger">*</span>
                      </label>
                      <div class="position-relative">
                        <input
                            id="old_password"
                            v-model="old_password"
                            :class="{ 'is-invalid': errors.old_password }"
                            :type="showOldPassword ? 'text' : 'password'"
                            class="form-control"
                            placeholder="Nhập mật khẩu cũ"
                        />
                        <span
                            class="toggle-password"
                            @click="toggleOldPassword"
                        >
                          <i
                              :class="{
                              'fas fa-eye': showOldPassword,
                              'fas fa-eye-slash': !showOldPassword,
                            }"
                          ></i>
                        </span>
                      </div>
                      <div v-if="errors.old_password" class="text-danger">
                        {{ errors.old_password }}
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-7 col-md-7">
                    <div class="input-space">
                      <label class="form-label">
                        Mật khẩu mới <span class="text-danger">*</span>
                      </label>
                      <div class="position-relative">
                        <input
                            id="new_password"
                            v-model="new_password"
                            :class="{ 'is-invalid': errors.new_password }"
                            :type="showNewPassword ? 'text' : 'password'"
                            class="form-control"
                            placeholder="Nhập mật khẩu mới"
                        />
                        <span
                            class="toggle-password"
                            @click="toggleNewPassword"
                        >
                          <i
                              :class="{
                              'fas fa-eye': showNewPassword,
                              'fas fa-eye-slash': !showNewPassword,
                            }"
                          ></i>
                        </span>
                      </div>
                      <div v-if="errors.new_password" class="text-danger">
                        {{ errors.new_password }}
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-7 col-md-7">
                    <div class="input-space mb-0">
                      <label class="form-label">
                        Xác nhận mật khẩu <span class="text-danger">*</span>
                      </label>
                      <div class="position-relative">
                        <input
                            id="confirm_password"
                            v-model="confirm_password"
                            :class="{ 'is-invalid': errors.confirm_password }"
                            :type="showConfirmPassword ? 'text' : 'password'"
                            class="form-control"
                            placeholder="Xác nhận mật khẩu"
                        />
                        <span
                            class="toggle-password"
                            @click="toggleConfirmPassword"
                        >
                          <i
                              :class="{
                              'fas fa-eye': showConfirmPassword,
                              'fas fa-eye-slash': !showConfirmPassword,
                            }"
                          ></i>
                        </span>
                      </div>
                      <div v-if="errors.confirm_password" class="text-danger">
                        {{ errors.confirm_password }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="save-changes text-end">
                  <button class="btn btn-secondary save-profile" type="submit">
                    Lưu thay đổi
                  </button>
                </div>
              </Form>
            </div>
          </div>
        </div>
        <div v-else class="col-sm-12">
          <button class="btn btn-primary" @click="sendMailResetPassword">Đặt lại mật khẩu</button>
        </div>
      </div>
    </div>
  </div>
  <layout-footer></layout-footer>
</template>

<script setup>
import {Form} from "vee-validate";
import {ref, reactive, computed} from "vue";
import userPlayerService from "@/stores/user-player";
import {message} from "ant-design-vue";
import emailService from "@/stores/email";

const title = "Đổi mật khẩu";
const text = "Trang chủ";
const text1 = "Đổi mật khẩu";

const old_password = ref("");
const new_password = ref("");
const confirm_password = ref("");

const showOldPassword = ref(false);
const showNewPassword = ref(false);
const showConfirmPassword = ref(false);

const user = computed(() => JSON.parse(localStorage.getItem('user')));
const hiddenForm = ref(!!user.value?.info?.social_type);

const errors = reactive({});

const validateForm = () => {
  Object.keys(errors).forEach((key) => delete errors[key]);

  let isValid = true;

  if (!old_password.value.trim()) {
    errors.old_password = "Mật khẩu cũ không được để trống";
    isValid = false;
  }
  if (!new_password.value.trim()) {
    errors.new_password = "Mật khẩu mới không được để trống";
    isValid = false;
  } else if (new_password.value.length < 6) {
    errors.new_password = "Mật khẩu mới phải có ít nhất 6 ký tự";
    isValid = false;
  }
  if (!confirm_password.value.trim()) {
    errors.confirm_password = "Xác nhận mật khẩu không được để trống";
    isValid = false;
  } else if (confirm_password.value !== new_password.value) {
    errors.confirm_password = "Xác nhận mật khẩu không khớp với mật khẩu mới";
    isValid = false;
  }
  return isValid;
};

const validateAndSubmit = async () => {
  if (validateForm()) {
    try {
      const data = {
        old_password: old_password.value,
        new_password: new_password.value,
        confirm_password: confirm_password.value,
      };

      const response = await userPlayerService.changePassword(data);
      if (response?.data) {
        message.success("Thay đổi mật khẩu thành công!");
        resetForm();
      } else {
        message.error("Thay đổi mật khẩu thất bại. Vui lòng thử lại.");
      }
    } catch (error) {
      console.log(error);
      message.error(error?.response?.data?.details ?? "Thay đổi mật khẩu thất bại. Vui lòng thử lại.");
    }
  } else {
    message.error("Vui lòng kiểm tra lại thông tin.");
  }
};

const sendMailResetPassword = async () => {
  try {
    await emailService.resetPassword({});
    message.success("Thành công. Vui lòng kiểm tra email của bạn!");
    hiddenForm.value = false;

    const newUser = JSON.parse(localStorage.getItem('user'));
    newUser.user.social_type = null;
    localStorage.setItem('user', JSON.stringify(newUser));
  } catch (error) {
    console.log(error);
    message.error(error?.response?.data?.details ?? "Thất bại. Vui lòng thử lại.");
  }
}

const resetForm = () => {
  old_password.value = "";
  new_password.value = "";
  confirm_password.value = "";
  Object.keys(errors).forEach((key) => delete errors[key]);
};

const toggleOldPassword = () => {
  showOldPassword.value = !showOldPassword.value;
};
const toggleNewPassword = () => {
  showNewPassword.value = !showNewPassword.value;
};
const toggleConfirmPassword = () => {
  showConfirmPassword.value = !showConfirmPassword.value;
};
</script>

<style scoped>
.toggle-password {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  z-index: 10;
}

.position-relative {
  position: relative;
}
</style>
